module.exports = __webpack_public_path__ + "img/heart_alarm@2x.93810a4c.png";